
/**
 * Normalizes a string by removing whitespace for consistent comparison.
 * @param {string} str 
 * @returns {string}
 */
const normalize = (str) => str.replace(/\s+/g, '');

/**
 * Sorts report items based on specific priority rules:
 * 1. Sugar 50kg
 * 2. Sugar 10kg
 * 3. Sugar 5kg
 * Rest sorted alphabetically by name.
 * 
 * @param {Array} items - Array of objects, each must have a 'name' property.
 * @returns {Array} - New sorted array.
 */
export const sortReportItems = (items) => {
    if (!items) return [];

    // Normalized targets
    const TARGET_50 = normalize('سكر 50 كيلو');
    const TARGET_10 = normalize('سكر 10 كيلو');
    const TARGET_5 = normalize('سكر 5 كيلو');

    return [...items].sort((a, b) => {
        const nameA = a.name || '';
        const nameB = b.name || '';

        const normA = normalize(nameA);
        const normB = normalize(nameB);

        // 1. Check for Sugar 50kg
        const is50A = normA === TARGET_50;
        const is50B = normB === TARGET_50;
        if (is50A && !is50B) return -1;
        if (!is50A && is50B) return 1;

        // 2. Check for Sugar 10kg
        const is10A = normA === TARGET_10;
        const is10B = normB === TARGET_10;
        if (is10A && !is10B) return -1;
        if (!is10A && is10B) return 1;

        // 3. Check for Sugar 5kg
        const is5A = normA === TARGET_5;
        const is5B = normB === TARGET_5;
        if (is5A && !is5B) return -1;
        if (!is5A && is5B) return 1;

        // 4. Alphabetical sort for everything else
        return nameA.localeCompare(nameB, 'ar');
    });
};
